import React, { ReactElement, useEffect, useState } from "react";
import Head from "next/head";
import ReadyToMoveBanner from "@/components/landing-new/ReadyToMoveBanner";
import getConfig from "next/config";
import { MainLayout } from "@/containers/layout/NowLayout";
import { getAllStoredUTMParams } from "@/shared/hooks/useUTMTracker";
import { getReferrer } from "@/shared/hooks/useReferralTracker";
import Landing from "@/components/register/Landing";
import { useRouter } from "next/router";

const { publicRuntimeConfig } = getConfig();

const KeyzyNow = (): JSX.Element => {
  const router = useRouter();
  const [iframeSrc, setIframeSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    const params = new URLSearchParams();

    const referrer = getReferrer();
    if (referrer) {
      params.set("referred_by", referrer);
    }

    const utmParams = new URLSearchParams(getAllStoredUTMParams());
    utmParams.forEach((value, key) => {
      params.set(key, value);
    });

    const baseUrl = publicRuntimeConfig.NEXT_TYPEFORM_NOW_REGISTER_INTEREST_URL;
    const src = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

    setIframeSrc(src);
  }, []);

  return (
    <>
      <Head>
        <title>Start your Application for Rent to Buy with Keyzy</title>
        <link rel="canonical" href="https://www.keyzy.com/register" />
        <meta
          name="description" key="description"
          content="Register for Keyzy’s rent-to-own homes and start your journey to homeownership. Fixed rent, no upfront deposit, and a flexible path to buying your dream home in London. Sign up today!"
        />
        <meta
          name="twitter:card"
          content="Register for Keyzy’s rent-to-own homes and start your journey to homeownership. Fixed rent, no upfront deposit, and a flexible path to buying your dream home in London. Sign up today!"
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/now/meta-og-keyzy-now.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Start your Application for Rent to Buy with Keyzy"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Register for Keyzy’s rent-to-own homes and start your journey to homeownership. Fixed rent, no upfront deposit, and a flexible path to buying your dream home in London. Sign up today!"
          key="ogdesc"
        />
      </Head>
      <div>
        {publicRuntimeConfig.NEXT_ENABLE_NEW_REGISTERATION_FLOW === "1" &&
        router.query.type !== "typeform" ? (
          <div>
            <Landing />
          </div>
        ) : (
          <>
            <div className="bg-white min-h-[600]">
              {iframeSrc && (
                <iframe key="1" src={iframeSrc} style={{ height: "600px", width: "100%" }} />
              )}
            </div>
            <div className="bg-white">
              <ReadyToMoveBanner />
            </div>
          </>
        )}
      </div>
    </>
  );
};

KeyzyNow.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default KeyzyNow;
